// extracted by mini-css-extract-plugin
module.exports = {"links":"SocialMedia_links__HD0oz","share":"SocialMedia_share__sxRaY"};